import {
  KeyboardEventHandler,
  MoveSelectionByOffsetOptions,
  findMentionInput,
  moveSelectionByOffset,
  removeMentionInput,
  isHotkeyPressed,
  getEditorString,
  getRange,
  getPointBefore,
  getPlugin,
  TMentionInputElement,
  ELEMENT_MENTION_INPUT,
  insertNodes,
} from '@udecode/plate';
import { PlateEditor, Value } from '@udecode/plate-common';

export const memoryOnKeyDownHandler: <V extends Value>(
  options?: MoveSelectionByOffsetOptions<V>
) => (editor: PlateEditor<V>) => KeyboardEventHandler = options => editor => event => {
  if (isHotkeyPressed('escape', event)) {
    const currentMentionInput = findMentionInput(editor)!;
    if (currentMentionInput) {
      event.preventDefault();

      removeMentionInput(editor, currentMentionInput[1]);
      return true;
    }
    return false;
  }

  if (event.key === '{') {
    const previousChar = getEditorString(
      editor,
      getRange(editor, editor.selection!, getPointBefore(editor, editor.selection!))
    );
    if (previousChar === '{') {
      event.preventDefault();

      const { type } = getPlugin<{}, any>(editor as any, ELEMENT_MENTION_INPUT);

      const data: TMentionInputElement = {
        type,
        children: [{ text: '' }],
        trigger: '/',
      };

      editor.deleteBackward('character');

      insertNodes<TMentionInputElement>(editor, data);
      return false;
    }
  }

  return moveSelectionByOffset(editor, options)(event);
};
